import React from 'react';
import BaseIcon from './BaseIcon.js';

const IconUsersMonitor = function ({ size }) {
  return (
    <BaseIcon viewBox="0 0 24 24" size={size}>
      <title>
      </title>
      <path d="M12,16.25a16.8,16.8,0,0,1,9.152,2.737.5.5,0,0,0,.683-.119A11.938,11.938,0,0,0,24,11.877,12.111,12.111,0,0,0,12.494.01,11.995,11.995,0,0,0,2.165,18.868a.5.5,0,0,0,.683.119A16.8,16.8,0,0,1,12,16.25ZM11.25,3.5a.75.75,0,0,1,1.5,0V5a.75.75,0,0,1-1.5,0ZM5,12.75H3.5a.75.75,0,0,1,0-1.5H5a.75.75,0,0,1,0,1.5ZM7.58,7.58a.75.75,0,0,1-1.061,0L5.459,6.521A.75.75,0,0,1,6.52,5.46L7.58,6.52A.749.749,0,0,1,7.58,7.58Zm4.339,6.866A2.365,2.365,0,0,1,10.232,10.4c.756-.756,7.042-4.631,7.756-5.071a.5.5,0,0,1,.688.688c-.44.715-4.315,7-5.071,7.756A2.379,2.379,0,0,1,11.919,14.446ZM19,12.75a.75.75,0,0,1,0-1.5h1.5a.75.75,0,0,1,0,1.5Z">
      </path>
      <path d="M12,17.75a15.05,15.05,0,0,0-8.031,2.3.507.507,0,0,0-.076.793,11.976,11.976,0,0,0,16.214,0,.507.507,0,0,0-.076-.793A15.044,15.044,0,0,0,12,17.75Z">
      </path>
    </BaseIcon>
  );
}

export default IconUsersMonitor;
